import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Inmediatamente después del pago recibís el link de descarga por email. Acceso en menos de 5 minutos. Sin espera, sin envío físico.'
}, {
  question: '2 — ¿Sirve para escuelita privada o solo para club de barrio?',
  answer: 'Para los dos. Cualquier espacio donde se enseñe Baby Fútbol en Argentina: club de barrio, escuelita privada, colegio, complejo deportivo o municipio.'
}, {
  question: '3 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos en el MegaPack estándar ($19.990) y en el combo con el Manual del DT Ganador ($27.990). La diferencia es el Manual del DT Ganador: estrategia de partido, scouting, 20 jugadas de pizarrón y psicología de banco.'
}, {
  question: '4 — ¿Sirve si soy profe nuevo o con poca experiencia?',
  answer: 'Es exactamente para vos. Cada sesión está redactada de principio a fin. No necesitás saber de táctica para usarlo: el material te guía paso a paso.'
}, {
  question: '5 — ¿Qué diferencia tiene con materiales gratuitos de YouTube?',
  answer: 'Los materiales de YouTube son ejercicios sueltos sin progresión, sin correcciones y sin adaptación al Baby Fútbol argentino de barrio. El MegaPack es un sistema de 40 semanas por nivel con objetivos progresivos y correcciones basadas en 20 años de experiencia en canchas argentinas.'
}, {
  question: '6 — ¿Por qué elegir el combo con el Manual del DT Ganador?',
  answer: 'Si solo entrenás, el estándar alcanza. Si el sábado también dirigís partidos, el Manual del DT Ganador te da lo que falta: scouting del rival, ajustes por marcador, cambios estratégicos, charlas del entretiempo y 20 jugadas de pizarrón con diagramas.'
}, {
  question: '7 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días sin preguntas. Escribís a soporteprofepack@gmail.com y te devolvemos el 100%. Sin formularios, sin justificaciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-152">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-153">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00C853] bg-[#000d08]' : 'border-[#00C853]/20 bg-black'}`} data-id="element-154">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-155">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-156">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#00C853] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-157">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-158">
                  <div className="h-px bg-[#00C853]/20 mb-4" data-id="element-159" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-160">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}